<template>
  <div class="h-auto">
    <empty-state class="w-auto mt-12 w-80">
      <template #icon>
        <slot name="icon">
          <v-icon class="mr-1" size="80" icon="$securityAwareness" />
        </slot>
      </template>
      <template #description>
        <span> {{ $t("securityAwarenessSettingsTab.notActivatedGenericTitle") }} </span>
      </template>
      <template #subtitle>
        <span>{{ $t("securityAwarenessSettingsTab.emptyStateSubtitle") }}</span>
      </template>
      <template #button>
        <v-btn class="mb-4" color="primary" rounded size="large" @click="handleAllowButtonClick()">
          {{ $t("securityAwarenessSettings.emptyState.activate") }}
        </v-btn>
      </template>
    </empty-state>
    <div class="d-flex justify-center pt-12 sa-empty-state-footer">
      <span class="body2 empty-state-footer-text text-center">
        <v-icon size="16" class="mr-1" icon="$warning" />
        {{ $t("securityAwarenessSettings.emptyState.warning", { n: daysToAllowList }) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import EmptyState from "@/components/EmptyState.vue";
import { useSecurityAwarenessEmptyState } from "@/composables/useSecurityAwarenessEmptyState.ts";
import { Service } from "@/constants/cloud-apps.ts";
import { RouteName } from "@/constants/routes.ts";
import { useSecurityAwarenessModule } from "@/_store/security-awareness/security-awareness.module.ts";

export default defineComponent({
  components: { EmptyState },
  props: {
    daysToAllowList: {
      type: Number,
    },
  },
  setup() {
    const satStore = useSecurityAwarenessModule();
    const { handleAllowButtonClick } = useSecurityAwarenessEmptyState();

    onMounted(async () => {
      if (!satStore.satConnections?.length) {
        await satStore.getSecurityAwarenessSettings();
      }
    });

    return {
      RouteName,
      Service,
      handleAllowButtonClick,
    };
  },
});
</script>

<style scoped lang="scss">
.empty-state-footer-text,
.icon-warning-xs:before {
  color: rgba(var(--v-theme-primary), 0.65);
}

.coro-widget {
  .coro-empty-state {
    margin-top: 0 !important;
  }

  .sa-empty-state-footer {
    width: 70%;
    padding-top: 12px !important;
    justify-self: center;
    align-items: inherit;
  }
}

.menu-heading {
  color: rgb(var(--v-theme-indigo-medium));
  font-size: 12px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  min-height: 0 !important;
}
</style>
